import PotmResultsMetaModel from "./PotmResultsMetaModel";
import PotmResultsModel from "./PotmResultsModel";

export default class PotmResultsResponseModel {
  public meta: PotmResultsMetaModel = new PotmResultsMetaModel();
  public data: PotmResultsModel[] = [];
}
